<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>ERP 시스템</h1>
    </div>
    <div class="product">
      <div>
        <h1>차량 관리 시스템</h1>
        &middot; &nbsp; 지입 기업용 ERP 시스템
        <br />
        차량, 보험, 회계 등 지입 관련 정보를 관리 할 수 있습니다.
      </div>
      <div>
        <h1>차량 관리 시스템 기능</h1>
        <FormTable :info="info"></FormTable>
      </div>
    </div>
  </div>
</template>

<script>
import FormTable from '../../static/FormTable.vue'
export default {
  components: { FormTable },
  data() {
    return {
      info: [
        {
          subject: '기초정보',
          element: '거래처 정보, 코드정보, 사용자 정보, 사업장 코드, 프린트 양식',
        },
        {
          subject: '차량정보',
          element: '차량정보',
        },
        {
          subject: '개인정보',
          element: '개인정보',
        },
        {
          subject: '보험정보',
          element: '보험정보',
        },
        {
          subject: '할부정보',
          element: '할부정보',
        },
        {
          subject: '기타정보',
          element: '사고정보,  변경정보,  운송정보,  계산서 정보, 직영차량관리, 용차매출 관리, 용차기사 등록, 운송마감 정리, 차량용품 관리, 유가 보조금 신청서',
        },
        {
          subject: '매출관리',
          element:
            '운송 매출 등록, 매출 수금 등록, 거래명세서 일괄 발행,  매출 세금 계산서 발행, 기간별 수금 현황, 외상 매출금 현황, 매출 거래처 원장, 차량별 청구 현황, 거래처별 청구 현황, 거래처별 청구 집계, 사업장별 차량 현황(실적신고), 사업장별 실적 현황(실적신고),',
        },
        {
          subject: '지출관리',
          element:
            '차량 지출 등록, 차량 수금 등록, 차량별 관리비 대장,차량별 원장, 차량 기초잔액, 매출전표 회계이체, 지불전표 회계이체, 수금전표 회계이체, 운송내역 회계이체, 지입료 회계이체, 정산표 회계이체',
        },
        {
          subject: '운송내역/매출',
          element: '운송정보, 매출정보, 지입관리, 기초금액 등록, 유대연비/단가, 엑셀 운송료 정산',
        },
        {
          subject: '기타관리',
          element: '분양정보',
        },
        {
          subject: '특별관리',
          element: '자료백업, 공지사항, 업데이트, 종료, 프린트 설정,자료변환, 사용자 정보,  회계연도, 자료보기',
        },
      ],
    }
  },
}
</script>

<style scoped>
@import '../../../style/content.css';
</style>
